import { FC } from 'react';

import Error from '@components/Error/Error';
import Loader from '@components/Loader/Loader';

import { ILoadableProps } from './Loadable.interface';

const Loadable: FC<ILoadableProps> = ({
  isLoading,
  error,
  onRetry,
  children,
  loaderClassName,
  loaderSize,
  errorClassName,
}) => {
  if (isLoading) return <Loader className={loaderClassName} size={loaderSize} />;
  if (error && typeof error === 'string')
    return <Error className={errorClassName} message={error} onRetry={onRetry} />;
  return children;
};

export default Loadable;
